export default __webpack_public_path__ + "static/media/findingVenus2.36fad9f1.wav";